// src/supabaseClient.js
import { createClient } from "@supabase/supabase-js";

// Replace with your Supabase credentials

const SUPABASE_URL = "https://wcoqsdbueqporwnngdab.supabase.co";
const SUPABASE_ANON_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Indjb3FzZGJ1ZXFwb3J3bm5nZGFiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzUyMjQwMDksImV4cCI6MjA1MDgwMDAwOX0.pcbx4EJwlck42reN3Y6yprj7vc5taOM1bYS8CuUSNTA";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // Parse #access_token / ?code= from email links (reset password, confirm signup)
    detectSessionInUrl: true,
  },
});
